/*
 *
 * Questionnaires actions
 *
 */

import { createAction } from '@reduxjs/toolkit';

import { SLICE_NAME } from './constants';

export const fetchList = createAction<boolean>(`${SLICE_NAME}/fetchList`);
export const addSection = createAction<{ seriesIdx: number }>(`${SLICE_NAME}/addSection`);
